// Shared helpers for writers: dry-run flags, logging, and user coercion.

// Parse various "truthy" env values
export function parseBoolish(v, defaultValue = false) {
    if (typeof v === "boolean") return v;
    if (v == null) return defaultValue;
    const s = String(v).trim().toLowerCase();
    if (["1", "true", "yes", "on", "enable", "enabled"].includes(s)) return true;
    if (["0", "false", "no", "off", "disable", "disabled", ""].includes(s)) return false;
    return defaultValue;
  }
  
  export function envDryRun() {
    return parseBoolish(process.env.REACT_APP_PP_FIRESTORE_DRY_RUN, false);
  }
  
  /** If `override` is exactly true/false, use it. Otherwise fallback to env. */
  export function isDryRunFlag(override) {
    if (override === true || override === false) return override;
    return envDryRun();
  }
  
  export function logDryRunBanner(scope, details = {}) {
    // eslint-disable-next-line no-console
    console.groupCollapsed(`[DRY RUN] ${scope}`);
    // eslint-disable-next-line no-console
    console.log(`REACT_APP_PP_FIRESTORE_DRY_RUN=${process.env.REACT_APP_PP_FIRESTORE_DRY_RUN} ⇒ DRY=${true}`);
    const keys = Object.keys(details || {});
    if (keys.length) {
      // eslint-disable-next-line no-console
      console.table(details);
    }
    // eslint-disable-next-line no-console
    console.groupEnd();
  }
  
  /** Accepts { user:{uid,email} } or { userId, userEmail } */
  export function coerceUser(obj) {
    const u = obj?.user;
    if (u?.uid && u?.email) return { uid: u.uid, email: String(u.email).toLowerCase() };
    if (obj?.userId && obj?.userEmail) {
      return { uid: obj.userId, email: String(obj.userEmail).toLowerCase() };
    }
    throw new Error("Missing user: provide { user:{uid,email} } or { userId, userEmail }");
  }
  